module.exports = __webpack_public_path__ + "static/media/cherrycredits.32e0a981.png";